const styles = `
  .tingle-modal * {
    box-sizing: border-box;
  }
  .tingle-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1100;
    display: -ms-flexbox;
    display: flex;
    visibility: hidden;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    background: rgba(0, 0, 0, .8);
    opacity: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    transition: transform .2s ease;
  }
  .tingle-modal--confirm .tingle-modal-box {
    text-align: center;
  }
  .tingle-modal--noOverlayClose {
    cursor: default;
  }
  .tingle-modal--noClose .tingle-modal__close {
    display: none;
  }
  .tingle-modal__close {
    position: fixed;
    top: 10px;
    right: 28px;
    z-index: 1100;
    padding: 0;
    width: 5rem;
    height: 5rem;
    border: none;
    background-color: transparent;
    color: #f0f0f0;
    font-size: 6rem;
    font-family: monospace;
    line-height: 1;
    cursor: pointer;
    transition: color .3s ease;
  }
  .tingle-modal__closeLabel {
    display: none;
  }
  .tingle-modal__close:hover {
    color: #fff;
  }
  .tingle-modal-box {
    position: relative;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin-top: auto;
    margin-bottom: auto;
    width: 50%;
    border-radius: 4px;
    background: #fff;
    opacity: 1;
    cursor: auto;
    transition: transform .3s cubic-bezier(.175, .885, .32, 1.275);
    -ms-transform: scale(.8);
    transform: scale(.8);
  }
  .tingle-modal-box__content {
    padding: 3rem 3rem 0 3rem;
  }
  .tingle-modal-box__footer {
    padding: 1.5rem 2rem;
    width: auto;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    cursor: auto;
  }
  .tingle-modal-box__footer::after {
    display: table;
    clear: both;
    content: "";
  }
  .tingle-modal-box__footer--sticky {
    position: fixed;
    bottom: -200px;
    z-index: 10001;
    opacity: 1;
    transition: bottom .3s ease-in-out .3s;
  }
  .tingle-enabled {
    position: fixed;
    right: 0;
    left: 0;
    overflow: hidden;
  }
  .tingle-modal--visible .tingle-modal-box__footer {
    bottom: 0;
  }
  .tingle-enabled .tingle-content-wrapper {
    filter: blur(8px);
  }
  .tingle-modal--visible {
    visibility: visible;
    opacity: 1;
  }
  .tingle-modal--visible .tingle-modal-box {
    -ms-transform: scale(1);
    transform: scale(1);
  }
  .tingle-modal--overflow {
    overflow-y: scroll;
    padding-top: 8vh;
  }
  @media (max-width : 540px) {
    .tingle-modal {
      top: 0px;
      display: block;
      padding-top: 60px;
      width: 100%;
    }
    .tingle-modal-box {
      width: auto;
      border-radius: 0;
    }
    .tingle-modal-box__content {
      overflow-y: scroll;
    }
    .tingle-modal--noClose {
      top: 0;
    }
    .tingle-modal--noOverlayClose {
      padding-top: 0;
    }
    .tingle-modal__close {
      top: 0;
      right: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 60px;
      border: none;
      background-color: #2c3e50;
      box-shadow: none;
      color: #fff;
      line-height: 55px;
    }
    .tingle-modal__closeLabel {
      display: inline-block;
      vertical-align: middle;
      font-size: 1.5rem;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    }
    .tingle-modal__closeIcon {
      display: inline-block;
      margin-right: .5rem;
      vertical-align: middle;
      font-size: 4rem;
    }
  }
  @supports ((-webkit-backdrop-filter: blur(12px)) or (backdrop-filter: blur(12px))) {
    .tingle-modal {
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
    }
    @media (max-width : 540px) {
      .tingle-modal {
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);
      }
    }
    .tingle-enabled .tingle-content-wrapper {
      filter: none;
    }
  }
`;

const injectToPage = () => {
  const styleNode = document.createElement('style');
  styleNode.type = 'text/css';

  const styleText = document.createTextNode(styles);
  styleNode.appendChild(styleText);
  document.getElementsByTagName('head')[0].appendChild(styleNode);
};

export default {
  injectToPage: injectToPage,
};
